module.exports = __webpack_public_path__ + "static/media/wikipediaViewer.8b25c69a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/wikipediaViewer.jpg
// module id = 79
// module chunks = 0